import { datadogRum } from '@datadog/browser-rum';

import { datadogLogger } from '../datadog/logger';

export function sendErrorReport(error: Error, context?: Record<string, unknown>): void {
    datadogRum.addError(error);
    datadogLogger.error(error.message, { error, ...context });
}
